/**
 * @module events/types/animationEnd
 */

/**
 * @type {string}
 */
export default 'animationend'
